import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export type MatchingRuleSettingsType = 'findview';
export type MatchingRule = 'cardealer' | 'leasing' | 'fleet';

export interface IMatchingRuleSettings {
  matching_rule: MatchingRule;
  settings_type: MatchingRuleSettingsType;
  settings: any;
  updated_at?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MatchingRuleService {

  constructor(private http: HttpClient) { }

  getAllMatchingRules(settingsType: MatchingRuleSettingsType): Observable<IMatchingRuleSettings[]> {
    return this.http.get<IMatchingRuleSettings[]>(`${environment.yomaApiURL}/settings/matching_rule/all`, {
      params: { settings_type: settingsType }
    });
  }

  getMatchingRule(settingsType: MatchingRuleSettingsType, matchingRule: MatchingRule): Observable<IMatchingRuleSettings> {
    return this.http.get<IMatchingRuleSettings>(`${environment.yomaApiURL}/settings/matching_rule`, {
      params: { settings_type: settingsType, matching_rule: matchingRule }
    });
  }

  postMatchingRule(settingsType: MatchingRuleSettingsType, matchingRule: MatchingRule, settings: any): Observable<IMatchingRuleSettings> {
    return this.http.post<IMatchingRuleSettings>(`${environment.yomaApiURL}/settings/matching_rule`, settings, {
      params: { settings_type: settingsType, matching_rule: matchingRule }
    });
  }

}
